import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2aa6380c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mark" }
const _hoisted_2 = { class: "msg-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "提示", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 您的考试时间已到，请立即交卷！ 不然将影响你的考试成绩。 ", -1))
const _hoisted_5 = { class: "button-list" }


    import {useRouter} from 'vue-router'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'time-up',
  props: ['score', 'msgText'],
  emits: ['callback', 'retry', 'submitQuestion'],
  setup(__props, { emit: __emit }) {

    const router = useRouter();
    const props = __props
    const emit = __emit
    
    const submitQuestion = () => {
        emit('submitQuestion', true)
    }


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          size: "large",
          type: "success",
          onClick: submitQuestion
        }, {
          default: _withCtx(() => [
            _createTextVNode("提交考卷")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})